function parseQuantity(input) {
  if (!input) return 1;

  const min = parseInt(input.getAttribute("min") || "1", 10);
  const step = parseInt(input.getAttribute("step") || "1", 10);
  let qty = parseInt(input.value, 10);

  if (isNaN(qty) || qty < min) qty = min;

  if (step > 1 && qty % step !== 0) {
    qty = Math.floor(qty / step) * step || min;
  }

  return qty;
}

function getCartApiErrorMessage(data) {
  const msg = data?.message;
  const desc = data?.description;

  // Shopify puts the limit/availability text in `message`; `description` is often generic.
  if (msg && (!desc || desc === "Cart Error")) return msg;
  if (desc && desc !== "Cart Error") return desc;
  return msg || desc || window.cartStrings?.error || "Error";
}

async function refreshMiniCartAfterAdd() {
  const cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer) return;

  try {
    const html = await fetch(`${routes.cart_url}?section_id=mini-cart`)
      .then((r) => r.text())
      .then((t) => new DOMParser().parseFromString(t, "text/html"));

    const sourceCartDrawer = html.querySelector("cart-drawer");
    const targetCartDrawer = document.querySelector("cart-drawer");
    if (targetCartDrawer && sourceCartDrawer) {
      targetCartDrawer.innerHTML = sourceCartDrawer.innerHTML;
    }

    const miniCartEl = html.querySelector("mini-cart");
    if (miniCartEl) {
      const totalCount = miniCartEl.getAttribute("data-cart-count");
      if (document.querySelector("#cartDrawer-count")) {
        document.querySelector("#cartDrawer-count").textContent =
          "(" + totalCount + ")";
      }
      const headerCount = document.querySelector("[data-header-cart-count]");
      if (headerCount) {
        headerCount.classList.toggle("hidden", totalCount == 0);
        if (totalCount > 0 && totalCount < 100)
          headerCount.textContent = totalCount;
      }
    }
  } catch (e) {
    console.error(e);
  }
}

function showAddedMessage(messageEl, qty) {
  if (!messageEl) return;
  const tpl =
    qty === 1
      ? window.quickOrderStrings?.itemAdded
      : window.quickOrderStrings?.itemsAdded;
  messageEl.textContent = (tpl || "").replace("[quantity]", String(qty));
}

async function getCartVariantQuantity(variantId) {
  const cart = await fetch(`${routes.cart_url}.js`).then((r) => r.json());
  return (cart.items || [])
    .filter((item) => String(item.variant_id) === String(variantId))
    .reduce((sum, item) => sum + (item.quantity || 0), 0);
}

async function syncVariantCartQuantity(variantEl, variantId) {
  const qtyInput = variantEl?.querySelector("[data-quick-order-qty-input]");
  if (!qtyInput) return;

  const count = await getCartVariantQuantity(variantId);
  qtyInput.setAttribute("data-cart-quantity", String(count));
}

async function addToCart(variantId, quantity) {
  const formData = new FormData();
  formData.append("id", variantId);
  formData.append("quantity", quantity);

  const config = fetchConfig("javascript");
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  delete config.headers["Content-Type"];
  config.body = formData;

  const response = await fetch(routes.cart_add_url, config);
  return response.json();
}

document.addEventListener("click", async (event) => {
  const btn = event.target.closest("[data-quick-order-add]");
  if (!btn) return;

  event.preventDefault();
  if (btn.disabled || btn.getAttribute("aria-disabled") === "true") return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  const variantEl = btn.closest(".quick-order__variant");
  const qtyInput = variantEl?.querySelector("[data-quick-order-qty-input]");
  const requestedQty = parseQuantity(qtyInput);

  const messageEl = variantEl?.querySelector(".quick-order__variant-message");
  if (messageEl) messageEl.textContent = "";

  btn.classList.add("loading");
  btn.setAttribute("aria-disabled", "true");

  try {
    const cartQtyBefore = await getCartVariantQuantity(variantId);
    const data = await addToCart(variantId, requestedQty);

    if (data?.status) {
      if (messageEl) messageEl.textContent = getCartApiErrorMessage(data);

      publish?.(PUB_SUB_EVENTS.cartUpdate, {
        source: "quick-order",
        productVariantId: parseInt(variantId, 10),
      });
      await refreshMiniCartAfterAdd();
      await syncVariantCartQuantity(variantEl, variantId);
      return;
    }

    if (data?.errors) {
      const msg =
        typeof data.errors === "string"
          ? data.errors
          : Object.values(data.errors).join(", ");
      if (messageEl) messageEl.textContent = msg;
      return;
    }

    const cartQtyAfter = await getCartVariantQuantity(variantId);
    const addedQty = cartQtyAfter - cartQtyBefore;
    showAddedMessage(messageEl, addedQty > 0 ? addedQty : requestedQty);

    publish?.(PUB_SUB_EVENTS.cartUpdate, {
      source: "quick-order",
      productVariantId: parseInt(variantId, 10),
    });

    await refreshMiniCartAfterAdd();
    await syncVariantCartQuantity(variantEl, variantId);
  } catch (e) {
    console.error(e);
    if (messageEl) messageEl.textContent = window.cartStrings?.error || "Error";
  } finally {
    btn.classList.remove("loading");
    btn.removeAttribute("aria-disabled");
  }
});
